import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=36f18b1a&scoped=true"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"
import style0 from "./Noticias.vue?vue&type=style&index=0&id=36f18b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f18b1a",
  null
  
)

export default component.exports